import type {
  CheckpointLearningBenchmark,
  LearningBenchmarkTier,
} from '../data/checkpointBenchmarks';

export interface ResolvedLearningTier {
  tier: LearningBenchmarkTier;
  index: number;
}

export function resolveLearningTier(
  benchmark: CheckpointLearningBenchmark,
  words: number,
): ResolvedLearningTier {
  let idx = 0;
  for (let i = 0; i < benchmark.tiers.length; i++) {
    if (words >= benchmark.tiers[i].minWords) idx = i;
  }
  return { tier: benchmark.tiers[idx], index: idx };
}

export function markerPercent(
  benchmark: CheckpointLearningBenchmark,
  words: number,
): number {
  const max = benchmark.displayMax;
  if (max <= 0) return 0;
  return Math.min(100, Math.round((words / max) * 100));
}

export function nextTierGoal(
  benchmark: CheckpointLearningBenchmark,
  words: number,
): string | null {
  const { index } = resolveLearningTier(benchmark, words);
  if (index >= benchmark.tiers.length - 1) return null;
  const next = benchmark.tiers[index + 1];
  const need = next.minWords - words;
  if (need <= 0) return null;
  return `Næste mål: ${next.minWords} ord (${need} mere)`;
}

export function isOverDisplayMax(
  benchmark: CheckpointLearningBenchmark,
  words: number,
): boolean {
  return words > benchmark.displayMax;
}
